module.exports = __webpack_public_path__ + "img/nikah-connect-logo.c5963e20.png";